module.exports = __webpack_public_path__ + "img/tk.3b362cdf.svg";